import React from "react"

import CompaniesCollection from "../../../../../core/gd-model/tree/companies-collection"
import HeaderAppTitle from "../../common/app-title/app-title"
import {BUS_TREE_CHANGE, SESSION_PROJECT_CHANGE} from "../../../../../core/gd/bus/bus-event-type"
import ProjectSession from "../../../../../core/model2/project/project-session"

// @ts-ignore
import ProjectIcon from '../../../../../core/gd-ui/project-icon/project-icon'
import {ProjectTree} from "../../../../../core/gd-model/tree/@type";

type Props = {
    projectId               : ID
    onChange?               : func
}

// const debug = "ProjectTitle"
const debug = false

export default class ProjectTitle extends React.Component<Props, any> {

    constructor(props: Props) {
        super(props)

        const { project, parents, isEditable } = this.init(props.projectId)

        this.state = {
            project     : project,
            parents     : parents,
            isEditable  : isEditable
        }
    }

    componentDidMount() {
        gd.bus.subscribe(SESSION_PROJECT_CHANGE, this, this.onProjectChanged)
        gd.bus.subscribe(BUS_TREE_CHANGE, this, this.updateParents)
    }

    shouldComponentUpdate(nextProps: Props, nextState: any) {
        return !_.isEqual(nextState, this.state) || nextProps.projectId !== this.props.projectId
    }

    UNSAFE_componentWillReceiveProps(newProps: Props) {
        if (newProps.projectId === this.props.projectId) return false

        this.updateState(newProps.projectId)
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this)
    }

    updateParents = () => {this.updateState(this.props.projectId)}

    updateState = (projectId: ID) => {
        const { project, parents, isEditable } = this.init(projectId)

        this.setState({
            project     : project,
            parents     : parents,
            isEditable  : isEditable
        })
    }

    onProjectChanged = (projectId: ID) => {
        if (this.state.project && this.state.project.id === projectId) {
            this.forceUpdate()
        }
    }

    init(projectId: ID) {
        // parents tree
        let parentTreeSource = new CompaniesCollection([gd.session.companies.get(gd.companyId)]);
        parentTreeSource.resetCompanyProjects(gd.companyId, {
            silent: true,
            includeArchived: true
        })

        const treeProject   = parentTreeSource.getProject(projectId)
        const project       = gd.session.projects.get(projectId)
        let parents: any = false

        if (!treeProject && (!project || !project.isTemplate)) {
            // do nothing (most likely project is deleted)
        } else {

            const filterProjects =
                // []
                // .concat(parentTreeSource.findProjectParents(treeProject)
                parentTreeSource.findProjectParents(treeProject)
                    .filter((p: ProjectTree)=>{ return gd.company.settings.projectAccess.showParentsDespiteAccess || !!p.access })
                    .map(
                        (p: ProjectTree)=>{
                            return {item:p}
                        })
                .slice(-2)

            if (filterProjects && filterProjects.length>0) {
                parents = filterProjects
            }
        }

        // EDITABLE
        const isEditable = gd.ac.check.project.fullAccess(projectId, project)

        return {
            project     : project,
            parents     : parents,
            isEditable  : isEditable
        }
    }

    onParentClick = (project: ProjectSession) => {
        debug && console.log(debug, 'onParentClick', project.properties?.handleExpandInsteadOfOpen, project)

        project.goTo()

        // if (!project.access || project.properties?.handleExpandInsteadOfOpen) return
        // this.props.onParentProjectClick(project.id)
    }

    onBlur = (newValue: any) => {
        if (!newValue || newValue.trim() === "") return

        this.state.project.name = newValue

        this.setState({
            project: this.state.project
        }, ()=>{
            // gd.api.Project.updateProfile(this.props.projectId, {name: newValue})
            gd.api.Project.update(this.props.projectId, {name: newValue})
        })
    }

    renderParents() {
        const result: any[] = []
        this.state.parents.map((parentProject: any, key: number)=>{
            const classes = Classes("parent-project max-w-150", {
                'no-hover': !parentProject.item.access
            })
            result.push(
                <div key        = {parentProject.item.id}
                     className  = {classes}
                     onClick    = {()=>{this.onParentClick(gd.session.projects.get(parentProject.item.id)!)}}>{parentProject.item.name}
                </div>)
            result.push(<div className="arrow-separator ui5-arrow-toggle s7 closed" key={key}/>)
        })
        return result
    }

    render() {
        return (
            <React.Fragment>
                {this.state.parents &&
                    this.renderParents()
                }

                {this.state.project &&
                    <React.Fragment>
                        <ProjectIcon project={this.state.project} type="app-header" className="icon-left" colorize />

                        <HeaderAppTitle name={this.state.project.name} editable={this.state.isEditable} onChange={this.onBlur} />

                        {this.state.project.isTemplate && <div className="template-mark">template</div>}
                        {this.state.project.isArchived && <div className="template-mark">archived</div>}
                    </React.Fragment>}
            </React.Fragment>
        );
    }
}